import { posterMockData } from "./mock/posterData";

export const getDataByAll = () => {
  return new Promise((resolve) => {
    // Simulasi loading 500ms
    setTimeout(() => {
      resolve(posterMockData);
    }, 500);
  });
};

export const getDataByLabel = (label) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = posterMockData.find(item => item.label === label);
      resolve(data);
    }, 200);
  });
};